<script>
  import { get } from 'svelte/store';
  import { conversationId } from '$lib/websocket-client.js';
  import CallWindow from './calls/CallWindow.svelte';

  export let call = {
    conversationId: get(conversationId),
    callType: 'audio',
    direction: 'outgoing',
    status: 'ringing'
  };
  export let onClose = null;
</script>

<CallWindow {call} mode="audio" {onClose} />
